/** The account menu's contents, in one place so the web popover and the native menus list the same things in the same words. */
import { MANUAL_PRESENCE_STATUSES, PRESENCE_LABELS, type PresenceStatus } from '../../types/presence';
import { d_logout, d_settings } from '../../shared/ui/iconPaths';

export const ACCOUNT_MENU_LABELS = {
  menu: 'Account menu',
  setStatus: 'Set status',
  resetStatus: 'Reset to automatic',
  settings: 'Settings',
  signOut: 'Sign out',
} as const;

export const ACCOUNT_STATUS_CHOICES: ReadonlyArray<{ id: PresenceStatus; label: string }> =
  MANUAL_PRESENCE_STATUSES.map(id => ({ id, label: PRESENCE_LABELS[id] }));

export type AccountMenuAction = 'settings' | 'signOut';

/** Settings opens the one Settings area, whose second nav holds Account, Preferences and the rest, so a single entry covers them all. */
export const ACCOUNT_MENU_ACTIONS: ReadonlyArray<{ id: AccountMenuAction; label: string; iconPath: string }> = [
  { id: 'settings', label: ACCOUNT_MENU_LABELS.settings, iconPath: d_settings },
  { id: 'signOut', label: ACCOUNT_MENU_LABELS.signOut, iconPath: d_logout },
];

/** The name the menu header shows: the same fallbacks the web sidebar uses. */
export function accountDisplayName(user: {
  displayName?: string | null; display_name?: string | null; name?: string | null;
  firstName?: string | null; first_name?: string | null; lastName?: string | null; last_name?: string | null;
  email?: string | null;
} | null | undefined, fallbackEmail?: string | null): string {
  const trimmed = (value: string | null | undefined) => value?.trim() || '';
  const email = trimmed(user?.email) || trimmed(fallbackEmail);
  return trimmed(user?.display_name) || trimmed(user?.displayName) || trimmed(user?.name)
    || [user?.first_name ?? user?.firstName, user?.last_name ?? user?.lastName].filter(Boolean).join(' ').trim()
    || email.split('@')[0] || '';
}
